import React from "react";
import PrivatePage from "../../components/PrivatePage";
import RevenueContainer from "./Revenue.container";
import RevenueUI from "./Revenue.UI";

const Revenue = (props) => {
    return(
        <PrivatePage>
            <RevenueContainer {...props}>
                <RevenueUI />
            </RevenueContainer>
        </PrivatePage>
    )
}

export default Revenue;